import React, { useContext, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, IconButton, TextField } from "@mui/material";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "AuthContextWrapper"
import { OUTCOMES } from "../../../constants";
import { UserAPI } from "apis/UserAPI";
import { EXECUTOR_VERIFICATION_STEP_BASIC_INFO_ID, EXECUTOR_VERIFICATION_SUBMITTED_ID } from ".";
import { ExecutorVerificationContext } from "ExecutorVerificationContextWrapper";

export const AboutYouPhone = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const { flow, user, setUser } = useAuthContext()
  const { verificationStepId, setStepStatusId, getStepStatusId, setVerificationStepId } = useContext(ExecutorVerificationContext);
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [phone, setPhone] = React.useState<string>(user?.phone || "");

  useEffect(() => {
    setVerificationStepId(EXECUTOR_VERIFICATION_STEP_BASIC_INFO_ID)
  }, [])

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    setIsSubmitting(true)

    try {
      if(!user) {
        return false
      }

      user.phone = phone
      setUser?.(user)
      await UserAPI.updatePhone(phone)

      if(getStepStatusId(verificationStepId) !== EXECUTOR_VERIFICATION_SUBMITTED_ID) {
        await setStepStatusId(verificationStepId, EXECUTOR_VERIFICATION_SUBMITTED_ID)
      }

    } catch (error) {
      console.error("issue updating step, " + (error as any)?.message)
      setIsSubmitting(false)
      return false
    }

    setIsSubmitting(false)
    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);

    return true;
  };

  const handleBack = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    flow?.navigateToNext(currentScreen, OUTCOMES.back, navigate);
    return true;
  };

  if (!currentScreen) {
    return <></>;
  }

  return (
    <FlowScreenWrapper title="Can you confirm that this is the best phone number to reach you at?">
      <div>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Phone number"
            margin="normal"
            name="text"
            value={phone}
            variant="outlined"
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
        </Box>
        <Box sx={{ my: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "space-between",
            }}
          >
            <Button
              color={"secondary"}
              variant="contained"
              disabled={isSubmitting}
              sx={{ minWidth: 180 }}
              onClick={handleComplete}
            >
              Continue
            </Button>
            <IconButton
              color={"secondary"}
              disabled={isSubmitting}
              aria-label="back"
              onClick={handleBack}
              sx={{ mr: 2 }}
            >
              <ArrowBackIcon color={"secondary"} />
            </IconButton>
          </Box>
        </Box>
      </div>
    </FlowScreenWrapper>
  );
};
